import { render, staticRenderFns } from "./PurchaseValueWidget.vue?vue&type=template&id=64dd05a4&scoped=true&"
import script from "./PurchaseValueWidget.vue?vue&type=script&lang=js&"
export * from "./PurchaseValueWidget.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseValueWidget.vue?vue&type=style&index=0&id=64dd05a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dd05a4",
  null
  
)

export default component.exports
import {QCard,QCardSection,QSelect,QSpinner,QField} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QSelect,QSpinner,QField})
